// Estados del documento (DocumentStatus del API). Fuente única para los contratos
// Zod y los mapas de presentación de todas las pantallas: un estado nuevo en el
// backend se agrega acá y el compilador señala cada mapa que debe cubrirlo.

export const DOCUMENT_STATUSES = [
  'reservado',
  'borrador',
  'en_revision',
  'en_aprobacion',
  'vigente',
  'obsoleto',
  // Reserva que no llegó a elaborarse: su código quedó libre (QA F1 #15).
  'anulado',
] as const;

export type DocumentStatus = (typeof DOCUMENT_STATUSES)[number];
